import React, {useContext, useEffect} from "react";
import {Formik, useFormikContext} from "formik";
import {usePolicyContext} from "./PolicyContext";
import FormFields from "../../../components/client/Proposal/ActionDailogs/QCPopUp/FormFields";
import {ApproveBankPopUpContext} from "./ApproveBankPopup";
import {fieldsName} from "../../client/Proposal/ActionDailogs/QCPopUp/utils";
import * as PaymentActions from "../../../actions/payment";
import {useActions} from "../../../actions";
import {ActionItems, UserUpdateRequestStatus} from "../../../constants";


export interface ApproveBankContentProps {
    client?: any
    children?: React.ReactNode,
    isRejected?: boolean,
    setIsRejected?: Function
    setPaymentMethodReject?: Function,
    handleSubmit?: Function,
    approve?: boolean,
    formValues?: any,
    setIsApproved?: Function

}


export default function ApproveBankPopUpContent(props: ApproveBankContentProps) {

    const {
        children,
        isRejected,
        approve,
        setIsApproved,
        setIsRejected,
        formValues,
        setPaymentMethodReject
    }: any = props;
    const {
        client,
        setSubmitting,
        setOpenPopup,
        actionPayload,
        clientPolicy,
        refreshList
    } = useContext(ApproveBankPopUpContext);


    const {policy}: any = usePolicyContext();
    const payment = useActions(PaymentActions);
    const clientName = `${client && client.user.firstName} ${client && client.user.lastName}`;
    const fromChangeBank = true;

    const initialValues = {
        [fieldsName.bankName]: "",
        [fieldsName.bankAccHolder]: "",
        [fieldsName.accountNumber]: ""
    };
    useEffect(() => {
        if (approve) {
            approveMethod().then(r => {});
        }

        if (isRejected) {
            rejectPaymentMethod().then(r => {});
        }
    }, [approve, isRejected])

    async function approveMethod() {
        //getting payment id of the new payment method
        const method = typeof actionPayload == "string" && JSON.parse(actionPayload);

        const res = policy && policy.paymentMethods.filter(m => m.recordKey !== method).map(m => payment.removePaymentMethod({
            policyNumber: m.policyNumber,
            recordKey: m.recordKey
        }))
        await Promise.all(res);

        await payment.updateStatusAdminActionItemStatus({
            clientPolicyId: clientPolicy.id,
            actionType: ActionItems.APPROVE_PAYMENT_METHOD.actionType,
            tag: UserUpdateRequestStatus.APPROVED
        });
        refreshList && refreshList();
        setSubmitting && setSubmitting(false);
        setIsApproved(false);
        setPaymentMethodReject(false);
        setOpenPopup(false);
    }

    async function rejectPaymentMethod() {
        // when new payment method is rejected by admin   
        const method = typeof actionPayload == "string" && JSON.parse(actionPayload);
        if (policy && policy.paymentMethods && policy.paymentMethods.length > 0) {
            const removePaymentMethodPayload = {
                policyNumber: policy.policyNumber,
                recordKey: method,
            };
            let resFromActionItemUpdate: any;
            let res = await payment.removePaymentMethod(removePaymentMethodPayload);
            if (res.success === true) {
                resFromActionItemUpdate = await payment.updateStatusAdminActionItemStatus({
                    clientPolicyId: clientPolicy.id,
                    actionType: ActionItems.APPROVE_PAYMENT_METHOD.actionType,
                    rejectionMessage: formValues.rejectionMessage,
                    internalNote: formValues.internalNote,
                    clientId: client.id,
                    tag: UserUpdateRequestStatus.REJECTED
                });
            }

            if (resFromActionItemUpdate) {
                setIsRejected(false);
            }
        }
        refreshList && refreshList();
        setSubmitting && setSubmitting(false);
        setIsRejected(false);
        setPaymentMethodReject(false);
        setOpenPopup(false);
    }


    return <Formik
            initialValues={initialValues}
            onSubmit={() => {
            }}
    >
        {({
              handleSubmit,
          }: any) => {
            return (<form id={"ApprovePaymentMethod"} onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
            }}>
                <Initializer/>
                <p>The following eACh payment has been initiated by {clientName}. Review the payment details and Reject
                    or Accept</p>
                <FormFields fromChangeBank={fromChangeBank}/>
                {children}
            </form>);
        }
        }
    </Formik>
};


const Initializer = (props: {}) => {
    const {policy}: any = usePolicyContext();
    const {client, actionPayload} = useContext(ApproveBankPopUpContext);
    const method = typeof actionPayload == "string" && JSON.parse(actionPayload);
    let newPaymentMethod = policy && policy.paymentMethods && policy.paymentMethods.filter(m => m.recordKey === method)[0];
    const {setValues} = useFormikContext<any>()
    React.useEffect(() => {
        if (newPaymentMethod) {
            setValues({
                [fieldsName.accountNumber]: newPaymentMethod.maskedAccountNumber,
                [fieldsName.bankName]: newPaymentMethod.bankName,
                [fieldsName.bankAccHolder]: client.user.firstName + " " + client.user.lastName || "",
                [fieldsName.checkFront]: newPaymentMethod.files.find((name) => name.includes("Frontofcheck"))
            })
        }
    }, [newPaymentMethod, client])

    return <></>
}



